module.exports = __webpack_public_path__ + "static/img/top_message_large.2fdf6f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/players/top_message_large.png
// module id = iUyC
// module chunks = 0